import React, { useEffect, useState } from "react";
import { Box, Stack, CardMedia, Card, Button, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { apiCall } from "../../../api";
import ProductDetailsTable from "./ProductDetailsTable";
import Qrcode from "../../Qrcode";
import { ToastContainer, toast } from "react-toastify";
import {
  deleteapparel,
  deleteProductImage,
  updateProductImage,
  getAppareluse,
  normalizeMainScreenProducts,
} from "../../../api/endpoint/apparelEndpoints";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import "react-toastify/dist/ReactToastify.css";
import html2canvas from "html2canvas";
import "../Components/ProductDetails.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareAlt, faDownload } from "@fortawesome/free-solid-svg-icons";

export const ProductDetails = ({ productDetails, onDeleteSuccess }) => {
  console.log("Product Details Received:", productDetails);
  const navigate = useNavigate();
  const [isQrDialogOpen, setIsQrDialogOpen] = useState(false);
  const [productImages, setProductImages] = useState([]);
  const [draggedIndex, setDraggedIndex] = useState(null);
  console.log(productDetails);
  const {
    uniqueRecordId,
    uniqueId,
    stylecode,
    stylename,
    fobcost,
    producttype,
    sampletype,
    id,
    category,
    subCategory,
    color,
    size,
    washtype,
    season,
    ocnumber,
    orderqty,
    gpt,
    imageUrls,
    fabcode,
    fabricdesc,
    count,
    construction,
    composition,
    gsm,
    cuttable,
  } = productDetails;

  useEffect(() => {
    const images = productDetails.imageItems?.length
      ? productDetails.imageItems
      : (productDetails.imageUrls || []).map((url, index) => ({
          id: productDetails.imageIds?.[index],
          url,
        }));

    const storageKey = `product-image-order-${productDetails?.id || productDetails?.uniqueId || productDetails?.uniqueRecordId}`;
    const savedOrder = localStorage.getItem(storageKey);
    const savedUrlsKey = `${storageKey}-urls`;
    const savedUrls = localStorage.getItem(savedUrlsKey);

    if (savedUrls) {
      try {
        const orderedImageUrls = JSON.parse(savedUrls);
        const orderedByUrl = orderedImageUrls
          .map((savedUrl) => images.find((image) => String(image.url) === String(savedUrl)))
          .filter(Boolean);
        const remainingImages = images.filter(
          (image) => !orderedImageUrls.some((savedUrl) => String(savedUrl) === String(image.url))
        );
        setProductImages([...orderedByUrl, ...remainingImages]);
        return;
      } catch (error) {
        console.error("Error restoring image order from localStorage", error);
      }
    }

    if (savedOrder) {
      try {
        const orderedIds = JSON.parse(savedOrder);
        const orderedImages = orderedIds
          .map((savedId) => images.find((image) => String(image.id) === String(savedId)))
          .filter(Boolean);
        const remainingImages = images.filter(
          (image) => !orderedIds.some((savedId) => String(savedId) === String(image.id))
        );
        setProductImages([...orderedImages, ...remainingImages]);
        return;
      } catch (error) {
        console.error("Error restoring image order from localStorage", error);
      }
    }

    setProductImages(images);
  }, [productDetails]);

  const persistImageOrder = async (orderedImages) => {
    const savedImages = orderedImages.filter((image) => image?.id);
    if (savedImages.length === 0) return;

    const storageKey = `product-image-order-${productDetails?.id || productDetails?.uniqueId || productDetails?.uniqueRecordId}`;
    localStorage.setItem(
      storageKey,
      JSON.stringify(savedImages.map((image) => image.id))
    );
    localStorage.setItem(
      `${storageKey}-urls`,
      JSON.stringify(savedImages.map((image) => image.url))
    );

    try {
      await Promise.all(
        savedImages.map((image, index) =>
          updateProductImage(image.id, {
            imageUrl: image.url,
            displayOrder: index + 1,
          })
        )
      );
    } catch (error) {
      console.error("Error updating image order:", error);
      toast.error("Failed to update image order.", {
        position: "top-right",
        autoClose: 1500,
      });
    }
  };

  const moveImage = (dragIndex, hoverIndex) => {
    if (dragIndex === hoverIndex) return;
    const next = [...productImages];
    const [moved] = next.splice(dragIndex, 1);
    next.splice(hoverIndex, 0, moved);
    setProductImages(next);
    persistImageOrder(next);
  };

  useEffect(() => {
    const productId = productDetails?.id || productDetails?.uniqueId;

    if (!productId) {
      return;
    }

    const hasImageIds = (productDetails.imageItems || []).some((image) => image?.id) ||
      (productDetails.imageIds || []).some(Boolean);

    if (hasImageIds) {
      return;
    }

    let isMounted = true;

    const fetchImagesWithIds = async () => {
      try {
        const data = await getAppareluse(productId);
        const normalizedProduct = normalizeMainScreenProducts([data])[0];

        if (!isMounted || !normalizedProduct?.imageItems?.length) {
          return;
        }

        setProductImages(normalizedProduct.imageItems);
      } catch (error) {
        console.error("Error fetching product image ids", error);
      }
    };

    fetchImagesWithIds();

    return () => {
      isMounted = false;
    };
  }, [productDetails]);

  const handlePrintQR = () => {
    // Implement the logic to print the QR code.
    const { stylecode } = productDetails;
    const { composition } = productDetails;
    // This could involve rendering the QR code to a new window and invoking the print dialog.
    const printWindow = window.open("", "_blank");
    printWindow.document.write(
      "<html><head><style>h4 { text-align: center; font-size: 20px; font-weight: 1000; color: black; font-family: 'Poppins', sans-serif; }</style></head><body>"
    );
    printWindow.document.write(document.getElementById("qrCode").innerHTML);
    printWindow.document.write(`<h4>${stylecode}</h4>`);
    printWindow.document.write(`<h4>${composition}</h4>`);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.print();
  };

  const logActivity = async (
    activityDescription,
    productName,
    uniqueRecordId
  ) => {
    try {
      const email = localStorage.getItem("userId") || "unknown";

      // Get current date and time
      const currentDate = new Date();

      // Convert current date and time to Indian Standard Time (IST)
      const istDate = currentDate.toLocaleString("en-US", {
        timeZone: "Asia/Kolkata",
      });

      await apiCall("/ActivityLogs", {
        method: "POST",
        body: JSON.stringify({
          user: email,
          activity: activityDescription,
          productName: `${productName} (${uniqueRecordId})`, // Concatenate product name and unique record id
          timestamp: istDate, // Use IST timestamp
        })
      });

      console.log("Activity logged:", activityDescription);
    } catch (error) {
      console.error("Error logging activity: ", error);
    }
  }

  // const productId = 'someProductId'; // The ID of the product to edit

  const handleEdit = () => {
    if (productDetails && productDetails.id) {
      navigate(`/EditApparel/${productDetails.id}`);
    } else {
      console.error("Error: No product ID available for navigation.");
      alert("Unable to edit: Product details missing.");
    }
  };

  const handleDelete = (itemid) => {
    // Confirm with the user before deleting
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this item?"
    );
    if (isConfirmed) {
      deleteapparel(itemid)
        .then(() => {
          toast.success("Product successfully deleted!", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
          logActivity("Product deleted", stylename, uniqueRecordId);

          if (onDeleteSuccess) {
            onDeleteSuccess();
          }
        })
        .catch((error) => {
          toast.error("Error removing product: " + error.message, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
        });
    }
  };

  const handleDeleteProductImage = async (image) => {
    const nestedImage =
      image?.image_data ||
      image?.imageData ||
      image?.product_image ||
      image?.productImage ||
      image?.product_images?.[0] ||
      image?.images?.[0];

    const imageId =
      image?.id ||
      image?.image_id ||
      image?.imageId ||
      image?.product_media_id ||
      image?.productMediaId ||
      image?.product_image_id ||
      image?.productImageId ||
      image?.image_ids?.[0] ||
      image?.imageIds?.[0] ||
      nestedImage?.image_id ||
      nestedImage?.imageId ||
      nestedImage?.id ||
      nestedImage?.product_media_id ||
      nestedImage?.productMediaId ||
      nestedImage?.product_image_id ||
      nestedImage?.productImageId ||
      nestedImage?.image_ids?.[0] ||
      nestedImage?.imageIds?.[0];

    console.log('[handleDeleteProductImage] full image object:', image);
    console.log('[handleDeleteProductImage] resolved imageId:', imageId);

    if (!imageId) {
      toast.error("Image id is missing. Please refresh and try again.", {
        position: "top-right",
        autoClose: 1500,
      });
      return;
    }

    const isConfirmed = window.confirm(
      "Are you sure you want to delete this image?"
    );

    if (!isConfirmed) {
      return;
    }

    try {
      await deleteProductImage(imageId);
      setProductImages((prevImages) =>
        prevImages.filter((item) => {
          const itemId =
            item?.id ||
            item?.image_id ||
            item?.imageId ||
            item?.product_media_id ||
            item?.productMediaId ||
            item?.product_image_id ||
            item?.productImageId ||
            item?.image_ids?.[0] ||
            item?.imageIds?.[0];
          return itemId !== imageId;
        })
      );
      toast.success("Image deleted successfully!", {
        position: "top-right",
        autoClose: 1000,
      });
      logActivity("Product image deleted", stylename, uniqueRecordId);
    } catch (error) {
      toast.error("Error deleting image: " + error.message, {
        position: "top-right",
        autoClose: 1500,
      });
    }
  };

  const handleDownloadScreenshot = () => {
    const element = document.getElementById("product-details-container");
    if (!element) {
      alert("No element found to capture.");
      return;
    }

    element.classList.add("screenshot-ready");

    html2canvas(element, {
      onclone: (document) => {
        const clonedElement = document.getElementById(
          "product-details-container"
        );
        const allElements = clonedElement.getElementsByTagName("*");
        for (let i = 0; i < allElements.length; i++) {
          allElements[i].style.transition = "none";
          allElements[i].style.animation = "none";
        }

        const hideElements =
          clonedElement.getElementsByClassName("hide-on-screenshot");
        Array.from(hideElements).forEach((el) => (el.style.display = "none"));
      },
      scale: 3, // Increase the scale for better resolution
      useCORS: true,
      logging: true,
    }).then((canvas) => {
      const fileName = `${stylename.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.png`; // Create a file name from stylename
      const imageDataUrl = canvas.toDataURL("image/png");
      triggerDownload(imageDataUrl, fileName);

      element.classList.remove("screenshot-ready");
    });
  };

  const triggerDownload = (imgURI, fileName) => {
    const link = document.createElement("a");
    link.href = imgURI;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleShareScreenshot = (imageDataUrl) => {
    fetch(imageDataUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const fileName = `${stylename.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.png`; // Dynamically generate file name from stylename
        const file = new File([blob], fileName, {
          type: "image/png",
        });
        const filesArray = [file];

        if (navigator.canShare && navigator.canShare({ files: filesArray })) {
          navigator
            .share({
              files: filesArray,
              title: "Product Details",
              text: `Check out the details of ${stylename}!`,
            })
            .then(() => console.log("Share was successful."))
            .catch((error) => console.error("Sharing failed", error));
        } else {
          console.error("Your system doesn't support sharing files.");
        }
      })
      .catch((err) =>
        console.error("Failed to convert image for sharing", err)
      );
  };

  const handleTakeAndShareScreenshot = () => {
    const element = document.getElementById("product-details-container");
    if (!element) {
      alert("No element found to capture.");
      return;
    }

    element.classList.add("screenshot-ready"); // Apply screenshot-specific styles

    html2canvas(element, {
      onclone: (document) => {
        const clonedElement = document.getElementById(
          "product-details-container"
        );
        // Disable all potential dynamic animations or transitions
        const allElements = clonedElement.getElementsByTagName("*");
        for (let i = 0; i < allElements.length; i++) {
          allElements[i].style.transition = "none";
          allElements[i].style.animation = "none";
        }

        const hideElements =
          clonedElement.getElementsByClassName("hide-on-screenshot");
        for (let i = 0; i < hideElements.length; i++) {
          hideElements[i].style.display = "none"; // This hides the buttons only in the cloned document
        }

        const qrCodeContainer = clonedElement.querySelector("#qrCode");
        if (qrCodeContainer) {
          qrCodeContainer.style.transform = "scale(1)"; // Ensure full size
          qrCodeContainer.style.transformOrigin = "top center";
          qrCodeContainer.style.marginTop = "10px"; // Add top margin for visibility
          qrCodeContainer.style.marginBottom = "10px"; // Add bottom margin to ensure space around QR
        }
      },
      scale: 3, // Adjust scale for higher quality
      useCORS: true,
      logging: true,
    }).then((canvas) => {
      const imageDataUrl = canvas.toDataURL("image/png");
      handleShareScreenshot(imageDataUrl);

      element.classList.remove("screenshot-ready"); // Remove temporary styles
    });
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Box
        id="product-details-container"
        display="flex"
        justifyContent="flex-start"
        sx={{
          bgcolor: "primary.card",
          // paddingTop: 2,
          // paddingLeft: 5,
          // paddingRight: 5,
        }}
      >
        {/* Left side for images */}
        <Box sx={{ width: "60%", display: "flex", flexWrap: "wrap", gap: 2 }}>
          {/* <Stack direction="row" spacing={2} wrap="wrap" justifyContent="flex-start"> */}
          {productImages.map((image, index) => (
            <Card
              key={image.id || image.url || index}
              draggable
              onDragStart={(event) => {
                event.dataTransfer.effectAllowed = "move";
                event.dataTransfer.setData("text/plain", String(index));
                setDraggedIndex(index);
              }}
              onDragOver={(event) => event.preventDefault()}
              onDrop={(event) => {
                event.preventDefault();
                const dragIndex = Number(event.dataTransfer.getData("text/plain"));
                if (!Number.isNaN(dragIndex)) {
                  moveImage(dragIndex, index);
                }
                setDraggedIndex(null);
              }}
              onDragEnd={() => setDraggedIndex(null)}
              sx={{
                width: "40%",
                mb: 2,
                position: "relative",
                border: draggedIndex === index ? "2px solid #1976d2" : "1px solid transparent",
                opacity: draggedIndex === index ? 0.75 : 1,
                cursor: "grab",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: 8,
                  left: 8,
                  zIndex: 2,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  px: 1,
                  py: 0.5,
                  borderRadius: 1,
                  bgcolor: "rgba(17, 24, 39, 0.92)",
                  color: "#fff",
                  fontSize: 12,
                  fontWeight: 700,
                }}
              >
                <DragIndicatorIcon fontSize="small" />
                Drag to reorder
              </Box>
              <IconButton
                onClick={() => handleDeleteProductImage(image)}
                className="hide-on-screenshot"
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  zIndex: 1,
                  color: "error.main",
                  backgroundColor: "rgba(255,255,255,0.85)",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,1)",
                  },
                }}
                size="small"
              >
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
              <CardMedia
                component="img"
                height="400"
                image={image.url}
                alt={`${producttype}-${index}`}
                title={`${producttype}-${index}`}
                sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
              />
            </Card>
          ))}
          {/* </Stack> */}
        </Box>

        {/* Right side for table and QR code */}
        <Box
          sx={{
            width: "40%",
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
          }}
        >
          <ProductDetailsTable productDetailsProps={productDetails} />
          <Box sx={{ ml: 3 }}>
            <div id="qrCode" style={{ height: "13em" }}>
              <Box sx={{ padding: "10px" }}>
                <Qrcode
                  uniqueRecordId={uniqueRecordId}
                  stylename={stylename}
                  stylecode={stylecode}
                  fobcost={fobcost}
                  sampletype={sampletype}
                  producttype={producttype}
                  category={category}
                  subCategory={subCategory}
                  color={color}
                  size={size}
                  washtype={washtype}
                  season={season}
                  ocnumber={ocnumber}
                  orderqty={orderqty}
                  fabcode={fabcode}
                  fabricdesc={fabricdesc}
                  count={count}
                  construction={construction}
                  composition={composition}
                  gpt={gpt}
                  gsm={gsm}
                  cuttable={cuttable}
                  showLogo={true}
                />
              </Box>
            </div>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                mt: 2,
                ml: 5,
                mr: 4,
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handlePrintQR}
                sx={{ mb: 2, width: "100%" }}
                className="hide-on-screenshot"
              >
                Print QR
              </Button>

              <Button
                variant="contained"
                color="secondary"
                onClick={handleEdit}
                sx={{ mb: 2, width: "100%" }}
                className="hide-on-screenshot"
              >
                Edit
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => handleDelete(id)}
                sx={{ width: "100%" }}
                className="hide-on-screenshot"
              >
                Delete
              </Button>
              <Box display="flex" sx={{ mt: 2 }}>
                <IconButton onClick={handleDownloadScreenshot} color="secondary" sx={{ ml: 5 }} className="hide-on-screenshot">
                  <FontAwesomeIcon icon={faDownload} />
                </IconButton>
                <IconButton onClick={handleTakeAndShareScreenshot} color="primary" sx={{ mr: 2 }} className="hide-on-screenshot">
                  <FontAwesomeIcon icon={faShareAlt} />
                </IconButton>

              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default ProductDetails;
